import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery, UpdateCourseDurationRequest } from "../../interfaces";

export const courseDurationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCourseDurations: builder.query<
      any,
      { gradeId: string; courseId: string; data: PaginateQuery }
    >({
      query: ({ gradeId, courseId, data }) => ({
        url: buildPaginationQueryString(
          data,
          `/api/course-duration/${gradeId}/${courseId}`,
        ),
      }),
      providesTags: ["CourseDurations"],
    }),
    getCourseDuration: builder.query<any, string>({
      query: (id) => ({ url: `/api/course-duration/${id}` }),
      providesTags: ["CourseDuration"],
    }),
    updateCourseDuration: builder.mutation<any, UpdateCourseDurationRequest[]>({
      query: (data) => ({
        url: "/api/course-duration",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [
        "CourseDurations",
        "CourseDuration",
        "Paginated-EducationalStages",
      ],
    }),
    deleteCourseDuration: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/course-duration/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CourseDurations"],
    }),
    rollover: builder.mutation<any, { courseId: string; curriculumId: string }>(
      {
        query: ({ courseId, curriculumId }) => {
          console.log(courseId);
          return {
            url: `/api/course-duration/rollover/course-grade/${courseId}?curriculumId=${curriculumId}`,
            method: "PATCH",
          };
        },
        invalidatesTags: [
          "CourseDurations",
          "Paginated-EducationalStages",
          "Paginated-Students",
        ],
      },
    ),
  }),
});

export const {
  useGetCourseDurationsQuery,
  useGetCourseDurationQuery,
  useUpdateCourseDurationMutation,
  useDeleteCourseDurationMutation,
  useRolloverMutation,
} = courseDurationApi;
